module.exports = "/fonts/vendor/lightcase/src/lightcase.svg?1fe4f32a4e348630899d79bea5143e75";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightcase/src/fonts/lightcase.svg?55356177
// module id = 303
// module chunks = 1 2